import React from "react";

import { BiUser } from "react-icons/bi";
import {
  MdDashboard,
  MdBatchPrediction,
  MdQuiz,
  MdSmartToy,
} from "react-icons/md";
import { FaPersonCircleCheck } from "react-icons/fa6";
import { IoMdSettings } from "react-icons/io";
import { FaNewspaper } from "react-icons/fa";

export const links = [
  {
    title: "sidebar.dashboard",
    links: [
      {
        type: "route",
        name: "sidebar.dashboard",
        path: "/dashboard",
        icon: <MdDashboard />,
      },
    ],
  },
  {
    title: "sidebar.predictions",
    links: [
      // {
      //   type: "route",
      //   name: "sidebar.profile",
      //   path: "/profile",
      //   icon: <BiUser />,
      // },
      {
        type: "route",
        name: "sidebar.predictions",
        path: "/predictions",
        icon: <MdBatchPrediction />,
      },
      {
        type: "route",
        name: "sidebar.promises",
        path: "/promises",
        icon: <MdBatchPrediction />,
      },
      {
        type: "route",
        name: "sidebar.survey",
        path: "/surveys",
        icon: <MdQuiz />,
      },
      {
        type: "route",
        name: "Կանխատեսողներ",
        path: "/predictors",
        icon: <FaPersonCircleCheck />,
      },
      {
        type: "route",
        name: "Նորություններ",
        path: "/news",
        icon: <FaNewspaper />,
      },
      {
        type: "route",
        name: "Ավտոմատացում",
        path: "/automations",
        icon: <MdSmartToy />,
      },
      {
        type: "route",
        name: "sidebar.main",
        path: "/main",
        icon: <IoMdSettings size={22} />,
      },
    ],
  },
];

export const dashboardItems = [
  {
    slug: "predictions",
    type: "route",
    name: "Կանխատեսումներ",
    path: "/predictions",
    icon: <MdBatchPrediction color="#2D34FF" size="40" />,
    color: "red",
  },
  {
    slug: "promises",
    type: "route",
    name: "Խոստումներ",
    path: "/promises",
    icon: <MdBatchPrediction color="#2D34FF" size="40" />,
    color: "red",
  },
  {
    slug: "predictors",
    type: "route",
    name: "Կանխատեսողներ",
    path: "/predictors",
    icon: <FaPersonCircleCheck color="#2D34FF" size="40" />,
    color: "red",
  },
  {
    slug: "surveys",
    type: "route",
    name: "Ընդհանրական",
    path: "/surveys",
    icon: <MdQuiz color="#2D34FF" size="40" />,
    color: "red",
  },
];
